import { api } from '@/boot/axios'

/**
 * @param {{ q?: string, per_page?: number }} params
 */
export async function searchBillToEntities (params = {}) {
  const response = await api.get('/bill-to-entities', { params })

  return response.data
}
